import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';

/**
 *   The aim of this function is to provide TS transpiler with place, where it can:
 *      a) give hints of possible CSS properties in input object
 *      b) properly infer output object keys
 */
export function defineStyles<TKeys extends keyof T, T extends Record<TKeys, SystemStyleObject<Theme>>>(
  stylesObject: T
): Readonly<T> {
  return stylesObject;
}

/**
 *  simple function for inline style definition
 */
export function defineStyle(styleObject: SystemStyleObject<Theme>) {
  return styleObject;
}
